module.exports = __webpack_public_path__ + "static/media/IMG_0383.ca5a5bba.JPG";